import React, { useState, useCallback } from 'react';
import { Modal, Row, Col } from 'antd';
import { createSanitizedHTML } from '../../utils/sanitize';
import './Modal.scss';

export default ({ children, title, toggle, explanation, ...props }) => {
  const [visible, setVisible] = useState(false);
  const [description, setDescription] = useState(explanation);
  const show = useCallback(() => setVisible(true), []);
  const hide = useCallback(() => setVisible(false), []);

  return (
    <>
      {toggle(show)}
      <Modal
        title={title}
        width={description ? 600 : 500}
        footer={null}
        maskClosable={false}
        keyboard={false}
        className="modal"
        {...props}
        visible={visible}
        onCancel={hide}
        // Ant Design 3: zoom-leave + centered jumps, and destroyOnClose during
        // leave tears the dialog down mid-animation. Instant hide avoids both.
        // Also avoid setState in afterClose — it re-renders Dialog and clears
        // the inline display:none from onAnimateLeave, causing a second flash.
        transitionName=""
        maskTransitionName=""
        destroyOnClose
      >
        {explanation ? (
          <Row gutter={48} type="flex">
            <Col span={16}>{children(hide, setDescription)}</Col>
            <Col span={8} className="modal-description">
              <div className="modal-description-title">{description.title}</div>
              {typeof description.text === 'string' ? (
                <div dangerouslySetInnerHTML={createSanitizedHTML(description.text)} />
              ) : (
                <div className="modal-description-text">{description.text}</div>
              )}
            </Col>
          </Row>
        ) : (
          children(hide)
        )}
      </Modal>
    </>
  );
};
